import { createContext, useContext, useState } from "react";

type StatusResponse = "success" | "error";

type StatusScreenContextType = {
  statusResponse: StatusResponse | null;
  setStatusResponse: (status: StatusResponse | null) => void;
  isStatusScreenOpen: boolean;
  setIsStatusScreenOpen: (isOpen: boolean) => void;
};

type StatusScreenProviderProps = {
  children: React.ReactNode;
};

const StatusScreenContext = createContext<StatusScreenContextType>({
  statusResponse: null,
  setStatusResponse: () => {},
  isStatusScreenOpen: false,
  setIsStatusScreenOpen: () => {},
});

export const StatusScreenProvider = ({ children }: StatusScreenProviderProps) => {
  const [isStatusScreenOpen, setIsStatusScreenOpen] = useState(false);
  const [statusResponse, setStatusResponse] = useState<StatusResponse | null>(null);

  return (
    <StatusScreenContext.Provider
      value={{
        isStatusScreenOpen,
        setIsStatusScreenOpen,
        statusResponse,
        setStatusResponse,
      }}
    >
      {children}
    </StatusScreenContext.Provider>
  );
};

export const useStatusScreenContext = () => {
  const context = useContext(StatusScreenContext);
  if (!context) {
    throw new Error("useStatusScreenContext must be used within a StatusScreenProvider");
  }
  return context;
};
